<template>
    <v-content :style="{color:style.fontColor}" v-if="userIsAuthenticated">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <h1 :style="`color:${mainColor}`">Categorías</h1>
                    </v-row>
                </v-col>
                <v-col class="text-center" cols="12" v-if="onLoading">
                    <loading-circular/>
                </v-col>
            </v-row>
            <v-row class="mb-5 mt-2"   >
                <v-col cols="2" offset="10" v-if="categories.length > 0 && !onLoading">
                    <v-btn :color="mainColor" dark  @click="goToNew()">Nueva categoría</v-btn>
                </v-col>
            </v-row>
            <v-row class="pt-5" v-if="categories.length === 0 && !onLoading">
              <v-col cols="12" class="text-center">
                <h4>Crea primero las categorías antes de agregar los productos</h4>
              </v-col>
              <v-col cols="12" class="text-center">
                  <v-btn :color="mainColor" dark @click="goToNew()">Nueva categoría</v-btn>
              </v-col>
            </v-row>
            <v-row  >
                <v-col cols="8" offset="2" v-for="(category, index) in categories" :key="index" class="mb-5">
                    <v-card :style="{color:style.fontColor}" hover>
                        <v-container fluid style="cursor: default">
                            <v-row class="pb-1"  >
                                <v-col cols="4">
                                    <v-card-title primary-title class="pt-3">
                                        <div>
                                            <h3>{{category.categoryName}}</h3>
                                        </div>
                                    </v-card-title>
                                    <v-img
                                        :src="category.imageUrl"
                                        height="125px"
                                        contain
                                        class="ml-0"
                                    ></v-img>
                                </v-col>
                                <v-col cols="5">
                                    <v-card-text primary-title class="pt-3 ml-3">
                                        <div>
                                            <h3 class="mb-0">{{category.shortDescription}}</h3>
                                        </div>
                                    </v-card-text>
                                    <v-card-text primary-title class="pt-3 ml-3">
                                        <div>
                                        <p style="font-weight: bold">Estado: <span style="font-weight: 400">{{category.status === 'draft'? 'Borrador' : category.status === 'published'? 'Publicado' : 'Baja'}}</span></p>
                                        <p style="font-weight: bold">Creado en: <span style="font-weight: 400">{{new Date(category.creationDate.seconds * 1e3).toString()  | dateFilter}}</span></p>
                                        <p style="font-weight: bold">{{category.parentCategory.name === 'none' ? 'Es categoría padre': category.parentCategory.name === null ? 'Sin categoría padre' : `Categoría Padre: ${category.parentCategory.name}`}}</p>
                                        </div>
                                    </v-card-text>
                                </v-col>
                                <v-col cols="3">
                                    <v-card-actions class="ml-5">
                                        <v-col class="text-right" >
                                            <v-btn :color="mainColor" outlined @click="goToEdit(category.categoryId)" icon>
                                                <v-icon>{{editIcon}}</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-card-actions>
                                    <v-card-actions class="ml-5">
                                        <v-col class="text-right" >
                                            <v-btn :color="mainColor" outlined @click="goToDelete(category.categoryId)" icon>
                                                <v-icon>{{deleteIcon}}</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-card-actions>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>
<script>
/* eslint-disable no-console */
import * as error from '../../../errorscode.json'
import { mdiPencilOutline, mdiDeleteOutline } from '@mdi/js'
import * as constants from '../../../constants.json'

export default {
  data () {
    return {
      categories: [],
      companyId: '',
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      },
      editIcon: mdiPencilOutline,
      deleteIcon: mdiDeleteOutline
    }
  },

  computed: {
    onLoading () {
      return this.$store.getters.getLoading
    },

    user () {
      return this.$store.getters.getUser
    },

    userIsAuthenticated () {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined
    }
  },

  watch: {
    /**
     * Fetching data if user is authenticated
     */
    async user (value) {
      console.log('value', value)
      if (value === null || value === undefined) {
        this.$router.push('/')
      } else {
        await this.fetchData()
      }
    }
  },

  created () {
    // Fetching the data when the view is created and the data is already being observed
    if (this.$store.getters.getCompanyStatus === 'inactive') {
      alert(error.ERROR100)
    } else {
      this.fetchData()
    }
  },

  methods: {
    async fetchData () {
      try {
        const user = this.$store.getters.getUser
        if (user) {
          if (user.role === 'mega_administrator') {
            this.companyId = localStorage.companyId
          } else {
            const companyData = this.$store.getters.getCompanyData
            this.companyId = companyData.companyId
          }

          await this.$store.dispatch('actionLoadCategories', { companyId: this.companyId })
          this.categories = this.$store.getters.getLoadedCategories
        }
      } catch (error) {
        throw error
      }
    },

    async goToEdit (categoryId) {
      console.log('categoryId ', categoryId)
      if (this.$store.getters.getCompanyStatus === 'inactive') {
        alert(error.ERROR100)
      } else {
        this.$router.push({ name: 'EditCategory', params: { companyId: this.companyId, id: categoryId } })
      }
    },

    async goToNew () {
      console.log('companyId ', this.companyId)
      if (this.$store.getters.getCompanyStatus === 'inactive') {
        alert(error.ERROR100)
      } else {
        localStorage.categoryId = 'null'
        this.$router.push({ name: 'CreateCategory', params: { companyId: this.companyId } })
      }
    },

    goToDelete (categoryId) {
      console.log('companyId ', this.companyId)
      console.log('categoryId ', categoryId)
      if (this.$store.getters.getCompanyStatus === 'inactive') {
        alert(error.ERROR100)
      } else {
        confirm('¿Deseas eliminar este item?') && this.$store.dispatch('actionDeleteCategory', { companyId: this.companyId, categoryId: categoryId })
      }
    }
  }
}
</script>
